import axios from "axios";
import { useState } from "react";
import AsyncSelect from "react-select/async";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api/";

const SelectProductReport = ({ aamarId, onUserSelect }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const fetchUsers = async (inputValue, callback) => {
    try {
      const result = await axios.get(
        `${BASE_URL}product/search/select/${aamarId}/${inputValue}`
      );

      let options = result.data.map((user) => ({
        label: `${user?.name} - [ ${user?.article_code} ]`,
        value: user._id,
      }));

      callback(options);
    } catch (error) {
      console.error("Error fetching Users:", error);
    }
  };

  const handleChange = (selected) => {
    setSelectedOption(selected);
    onUserSelect(selected ? selected.value : null); // Selected ID pass to parent
    console.log("Selected Product ID:", selected ? selected.value : null);
  };

  return (
    <AsyncSelect
      value={selectedOption}
      loadOptions={fetchUsers}
      placeholder="Select Product"
      onChange={handleChange}
      defaultOptions
      className="basic-single"
      classNamePrefix="select"
      isClearable
    />
  );
};

export default SelectProductReport;
